export default "__VITE_ASSET__Bas82FUJ__"